import { useEffect, useState, useCallback } from "react";
import { X } from "lucide-react";

// 전역 이미지 라이트박스 — 어느 페이지에서든 사진을 클릭하면 크게 볼 수 있게 한다.
// 작은 아이콘/로고나 링크·버튼 내부 이미지는 제외한다.
export default function GlobalImageLightbox() {
  const [src, setSrc] = useState(null);

  const close = useCallback(() => setSrc(null), []);

  useEffect(() => {
    const onClick = (e) => {
      const img = e.target?.closest?.("img");
      if (!img) return;
      // 명시적으로 줌 제외 표시된 이미지
      if (img.dataset.noZoom !== undefined) return;
      // 링크/버튼/라벨(업로드 등) 내부 이미지는 해당 동작을 우선
      if (img.closest("a, button, label, [role='button'], [data-no-zoom]")) return;
      // 너무 작은 이미지(아이콘/작은 썸네일 일부)는 제외
      const w = img.getBoundingClientRect().width;
      const h = img.getBoundingClientRect().height;
      if (w < 40 || h < 40) return;
      const url = img.currentSrc || img.src;
      if (!url || url.startsWith("data:image/svg")) return;
      e.preventDefault();
      e.stopPropagation();
      setSrc(url);
    };
    // capture 단계에서 가로채 부모 핸들러(카드 클릭 등)보다 먼저 처리
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (!src) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [src, close]);

  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/90 flex items-center justify-center p-4 animate-in fade-in duration-150"
      onClick={close}
      data-testid="image-lightbox-overlay"
    >
      <button
        onClick={close}
        className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/15 hover:bg-white/30 text-white flex items-center justify-center transition-colors"
        aria-label="닫기"
        data-testid="image-lightbox-close"
      >
        <X className="w-5 h-5" />
      </button>
      <img
        src={src}
        alt=""
        onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
        data-testid="image-lightbox-img"
      />
    </div>
  );
}
